const state = {
    file_name: [],
    file_type: ''
}
const mutations = {
    SETFILENAME: (state, file_name) => {
        state.file_name = file_name
    },
    SETFILETYPE: (state, file_type) => {
        state.file_type = file_type
    }
}
export default {
    namespaced: true,
    state,
    mutations
}
